import { forwardRef, CSSProperties } from 'react'
// import NextImage from 'next/image' // This thing is utter shit

type Props = {
  src: string
  alt: string

  id?: string
  title?: string

  className?: string
  style?: CSSProperties

  height?: number
  width?: number

  crossOrigin?: string

  onLoad?: () => void
  onError?: () => void
}

const Image = forwardRef(
  ({ src, alt, id, title, className, style, height, width, crossOrigin, onLoad, onError }: Props, ref: any) => {
    return (
      <img
        draggable="false" // Prevents selection and dragging of the actual image file itself
        ref={ref}
        src={src}
        alt={alt}
        id={id}
        title={title}
        className={className}
        style={style}
        height={height}
        width={width}
        cross-origin={crossOrigin}
        onLoad={onLoad}
        onError={onError}
      />
    )
  },
)

export default Image
